import { CSSProperties } from "react";

export default class ConfirmAvailabilityOfficeDialogViewStyle {
    date: CSSProperties = {
        fontWeight: 400
    }
}